'use strict';

/**
 * View for rendering the profile in the navigation
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/navigation-profile.hbs');

var NavigationProfileView = ItemView.extend({
    template: template,

    className: 'profile-info',

    modelEvents: {
        'change:profileName': 'render',
        'change:fullname': 'render',
        'change:profilePictureUrl': 'render',
    },
});

module.exports = NavigationProfileView;